import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import router from '@/router/index.js'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 15000 // 请求超时时间
  // 设置请求次数，请求的间隙
  // headers: {
  //     retry: 4,
  //     retryDelay: 1000
  // }
})
// // 跨域请求，允许保存cookie
// service.defaults.withCredentials = true
// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) {
    config.headers['content-type'] = 'application/json'
    config.headers['Authorization'] = 'Bearer ' + store.getters.token // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
        * code为非20000是抛错
        */
    const res = response.data
    if (res.code !== 20000) {
      // 50012:其他客户端登录了;
      if (res.code === 50012) {
        // var loading = true
        MessageBox.confirm(res.msg, '确定登录？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = instance.cancelButtonLoading = true

              store.commit('user/initInfo', res.data)
              store.commit('user/setState', 3)

              store.dispatch('user/FedLogIn').then(() => {
                done()
                setTimeout(() => {
                  instance.confirmButtonLoading = instance.cancelButtonLoading = false
                }, 300)
                router.push({ path: '/Index' })
              }).catch(() => {
                instance.confirmButtonLoading = instance.cancelButtonLoading = false
              })
            } else {
              done()
            }
          }
        }).catch(() => { })
      } else if (res.code === 50014) {
        MessageBox.confirm(res.msg, '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then((e) => {
          store.commit('user/clearInfo')
          location.reload()
        })
      } else if (res.code === 50020) {
        window.location.reload()
      } else {
        Message({
          message: res.msg,
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.reject(new Error(res.msg || 'Error'))
      // return Promise.reject(new Error(res.msg))
      // // return Promise.reject('error')

      // return res
    } else {
      return res
    }
  },
  error => {
    var msg = ''
    switch (error.response.status) {
      case 404: msg = '当前网络不佳，请稍后重试. [404]'; break
      case 401: msg = '登录令牌已失效'; break
      default: msg = '服务异常'; break
    }

    if (msg) {
      Message({
        message: msg,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  }
)

export default service




// WEBPACK FOOTER //
// ./src/utils/request.js